import { action } from '@ember/object';

import didUpdate from 'webapp/modifiers/did-update';
import ReportsEditorSlideInnerComponent from 'webapp/components/reports/editor/slide-inner';
import ReportsEditorSlideSettingsComponent from 'webapp/components/reports/editor/slide-settings';
import type { Args as ReportsViewerSlideOuterArgs } from 'webapp/components/reports/viewer/slide-outer';
import ReportsViewerSlideOuterComponent from 'webapp/components/reports/viewer/slide-outer';

import type ReportSlide from 'webapp/models-custom/report-slide';

interface Args extends ReportsViewerSlideOuterArgs {
	onUpdateSlide: (slide: ReportSlide) => void;
	onDuplicateSlide: (slide: ReportSlide) => void;
	onRemoveSlide: (slide: ReportSlide) => void;
	// onToggleBlockSettings: (isOpen: boolean) => void;
}

export default class ReportsEditorSlideOuterComponent extends ReportsViewerSlideOuterComponent<Args> {
	@action
	onUpdateSlideSettings(): void {
		this.args.onUpdateSlide(this.args.model);
	}

	@action
	onDuplicateSlide(): void {
		this.args.onDuplicateSlide(this.args.model);
	}

	@action
	onRemoveSlide(): void {
		this.args.onRemoveSlide(this.args.model);
	}
	<template>
		<div
			class="report_slide_ct"
			data-id={{@model.id}}
			{{didUpdate this.handleModelChangeEvent @model.board}}
		>

			<div class="report_slide_settings-and-inner">

				<ReportsEditorSlideSettingsComponent
					@model={{@model}}
					@onChange={{this.onUpdateSlideSettings}}
					@onDuplicate={{this.onDuplicateSlide}}
					@onRemove={{this.onRemoveSlide}}
				/>

				<ReportsEditorSlideInnerComponent>
					{{yield}}
				</ReportsEditorSlideInnerComponent>

			</div>

		</div>
	</template>
}
